import React, { useEffect, useState } from "react";
import "../Views/Workflow.css";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import WorkflowSidebarItems from "./WorkflowSidebarItems";
import {
  setMinimizeSidebarWorkflow,
  setSelectedWorkflowData,
  setSelectedWorkflowRun,
  setWorkflowNameStore,
  WorkflowsType,
} from "../../../store/one-query/workflowsSlice";
import { useNavigate, useParams } from "react-router-dom";
import ExpandIconArrow from "../../../Custom-imeges/Workflows-Icons/ExpandIconArrow";
import WorkflowsIcon from "../../../Custom-imeges/WorkflowsIcon";
import { setShowSignPopup } from "../../../store/one-query/chatsSlice";
import WorkflowNameModal from "./WorkflowNameModal";
import HistoryIcon from "../../../Custom-imeges/Workflows-Icons/HistoryIcon";
import WorkflowHistoryModal from "./WorkflowHistory";
import { useGetWorkFlowRunId } from "../../../store/Apis/WorkflowsApi";
import { Box, Typography } from "@mui/material";
import { WorkflowAppInputAndOutputTypes } from "../../../Helper";
import CreateWorkflowIcon from "../../../Custom-imeges/Workflows-Icons/NewWorflowIcon";

interface WorkflowSidebarProps {
  selectedAppOrder: number;
}
const WorkflowSidebar = ({ selectedAppOrder }: WorkflowSidebarProps) => {
  const dispatch = useAppDispatch();
  const { workflowId } = useParams<{ workflowId: string }>();
  const navigate = useNavigate();
  const minimizeSidebarWorkflow = useAppSelector(
    (s) => s.workflows.minimizeSidebarWorkflow
  );
  const selectedWorkflow = useAppSelector(
    (s) => s.workflows.selectedWorkflowData
  );
  const [show, setShow] = useState<boolean>(false);
  const [showWorkflowHistory, setShowWorkflowHistory] =
    useState<boolean>(false);
  const darkMode = useAppSelector((s) => s.User.darkMode);
  const isUserAuthenticated = useAppSelector((s) => s.User.IsAuthenticated);
  const workflowsData=useAppSelector((s)=>s.workflows.allWorkflows)
  const [selectedWorkflowRunId,setSelectedWorkflowRunId]=useState<string>("");
  const {data:selectedWorkflowRunData}=useGetWorkFlowRunId(selectedWorkflowRunId)
  const selectedWorkflowRun = useAppSelector(
      (s) => s.workflows.selectedWorkflowRun
    );
  const selectedAppSetting = selectedWorkflow.apps?.find(
        (app) => app.appOrder === selectedAppOrder
    );
  useEffect(()=>{
    if(!selectedWorkflowRun.id)
      setSelectedWorkflowRunId("")
  },[selectedWorkflowRun?.id])
  useEffect(() => {
    if (!selectedWorkflow.id) {
      if (workflowId) {
        const selected = workflowsData?.find(
          (workflow: WorkflowsType) => workflow.id === workflowId
        );
        selected && dispatch(setSelectedWorkflowData(selected));
      }
    }
  }, [workflowsData]);

  useEffect(() => {
    if (!workflowId) dispatch(setSelectedWorkflowData({} as WorkflowsType));
  }, [workflowId]);

  useEffect(() => {
    if (selectedWorkflowRunData)
      dispatch(setSelectedWorkflowRun(selectedWorkflowRunData));
  },[selectedWorkflowRunData])
   const setSelectedWorkflow = (workflowName: string) => {
    if(isUserAuthenticated){
    const selectedWorkflowData = workflowsData?.find(
      (app: WorkflowsType) => app.name === workflowName
    );
    if (selectedWorkflowData) {
      dispatch(
        setSelectedWorkflowRun({
          id: "",
          workflowId: "",
          name: "",
          createdAt: "",
          workflowAppResults: [],
        })
      );
      navigate(`/workflows/${selectedWorkflowData?.id}`);
    }
    }
    else{
      dispatch(
        setShowSignPopup({
          show: true,
          type: "Workflow",
          message: "To complete the process you need to Sign in.",
          btnTitle: "Sign In for Free",
          btnAction: "NavigateToLogin",
        })
      );
    }
  };

  const handleNewWorkflow = () => {
    if (isUserAuthenticated) setShow(true);
    else
      dispatch(
        setShowSignPopup({
          show: true,
          type: "New workflow",
          message: "To complete the process you need to Sign in.",
          btnTitle: "Sign In for Free",
          btnAction: "NavigateToLogin",
        })
      );
  };
  const handleNavigateToCreateWorkflow = (name: string) => {
    dispatch(setWorkflowNameStore(name));
    navigate("/workflows/create-workflow");
  };
  const handleClose = () => {
    setShow(false);
    dispatch(setWorkflowNameStore(""));
  };
  return (
    <>
        <div className={`workflow-sidebar `}>
          {!minimizeSidebarWorkflow ? (
            <div className="w-100" style={{ maxHeight: "90%" }}>
              <div className={`container-sidebar-workflow`}>
                <div className="mt-3 d-flex justify-content-center w-100 position-relative">
                  <span
                    className="expand-icon-workflow-sidebar-full-width"
                    onClick={() =>
                      dispatch(
                        setMinimizeSidebarWorkflow(!minimizeSidebarWorkflow)
                      )
                    }
                  >
                    <ExpandIconArrow className="custom-icon" />
                  </span>
                  <button
                    className={`btn-create-workflow ${
                      darkMode
                        ? "btn-create-workflow-dark"
                        : "btn-create-workflow-light"
                    }`}
                    onClick={handleNewWorkflow}
                  >
                    New workflow
                  </button>
                </div>
                <div className="Line-seperator"></div>
                <WorkflowSidebarItems
                  setSelectedWorkflow={setSelectedWorkflow}
                />
              </div>
            </div>
          ) : (
            <div
              className="w-100 d-flex flex-column align-items-center"
              style={{ gap: "12px" }}
            >
              <span
                style={{
                  rotate: "180deg",
                  gap: "8px",
                  backgroundColor: "var(--M-background75)",
                  padding: "4px",
                  borderRadius: "8px",
                  cursor:"pointer"
                }}
                className="expand-icon-workflow-sidebar"
                onClick={() =>
                  dispatch(setMinimizeSidebarWorkflow(!minimizeSidebarWorkflow))
                }
              >
                <ExpandIconArrow className="custom-icon" />
              </span>
              <span className="new-workflow-icon"
                onClick={handleNewWorkflow}
                >
                <CreateWorkflowIcon className="custom-icon" />
              </span>
              <span className="w-100 d-flex flex-column align-items-center">
                <div className="Line-seperator"></div>
              </span>
            </div>
          )}
          <span className="w-100 d-flex flex-column align-items-center workflow-history-container-icon">
            <span
              className="d-flex pb-2"
              style={{
                width: "86%",
                justifyContent: minimizeSidebarWorkflow
                  ? "center"
                  : isUserAuthenticated
                  ? "center"
                  : "end",
                alignItems: "center",
              }}
            >
              {isUserAuthenticated ? (
                minimizeSidebarWorkflow ? (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    onClick={() => setShowWorkflowHistory(true)}
                    style={{
                      cursor: "pointer",
                      padding: "8px",
                      gap: "8px",
                    }}
                  >
                    <HistoryIcon className="user-profile-edit-icon" />
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center maximize-history-btn-container"
                    onClick={() => setShowWorkflowHistory(true)}
                  >
                    <HistoryIcon className="user-profile-edit-icon" />
                    <Typography className="history-btn-title ms-1">
                      History
                    </Typography>
                  </div>
                )
              ) : null}
            </span>
          </span>
        </div>
      
      {show && (
        <WorkflowNameModal
          show={show}
          handleClose={handleClose}
          method={handleNavigateToCreateWorkflow}
        />
      )}
      {showWorkflowHistory && (
        <WorkflowHistoryModal
          show={showWorkflowHistory}
          setSelectedWorkflowRunId={setSelectedWorkflowRunId}
          handleClose={() => setShowWorkflowHistory(false)}
        />
      )}
    </>
  );
};

export default WorkflowSidebar;
